import { FacilityDataTypes } from "../../../types/facilitiy-data-types";
import { UserLocationDataTypes } from "../../../types/user-location-data-types";

export const renderInfoWindow = (
  content: string | Element | Text | null | undefined,
  ariaLabel: string | null | undefined
) => {
  return new google.maps.InfoWindow({
    content,
    ariaLabel,
  });
};

export const renderFacilitiyString = (facility: Pick<FacilityDataTypes, "name" | "clientName">) => {
    return `<div style="font-size: 14px;  padding: 16px">
      <div>
        <p style=""><span style="font-weight: 500;">Facility Name:</span> ${
          facility.name
        }</p>
        <p style=""><span style="font-weight: 500;">Facility Client Name:</span> ${
          facility.clientName
        }</p>
      </div>
    </div>`;
};

export const renderUserDiv = (user: UserLocationDataTypes) => {
  const { userName, phoneNumbers, email, clientName, source } = user;

  const phoneNumber =
    phoneNumbers?.filter((num) => num.primary)[0]?.number || "No phone number";
  const contentString = `
          <div class="map-incident-dialog">
            <p>
              <span>Name:</span>
               ${userName}
            </p>
            <p><span >Phone Number:</span> ${phoneNumber}</p>
            <p><span >Email:</span> ${email}</p>
            <p><span >Client Name:</span> ${clientName}</p>
            <p>
            <span>Source:</span>
              <span class="info-source">${
                source === "facility" ? "Stationed Facility" : source
              }</span>
            </p>
          </div>`;

  return contentString;
};
